export default "__VITE_ASSET__DOXAoykV__"